import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import ServerPricing from '../../homepage/header-banner/ServerPricing';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
// import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CardBoxRow from '../../container/Box/Components/CardBox-Row'
// import { MuiGrid } from '@mui/material';
import CommonTable from '../../container/Table/Components/CommonTable';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;


// Titlecloudcompute
function ScalableVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Dạng mở rộng - Private Kubernetes - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("확장형")} */}
                        {/* {Contentcloudcard("고성능 Local SSD replication Volume 적용 안정적인 서비스운영","모든 인스턴스에 물리적인 rCPU (1배수) 적용, 고용량의 메모리제공")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12} className='MuiGrid-card'>{CardBoxRow(
                                "<p class='typo-21-sm typo-medium typo-black'>Cấu hình Cluster Kubernetes riêng tư mở rộng</p>",

                                `
                                <p class='typo-14'>Cụm Kubernetes riêng tư mở rộng được triển khai trên hạ tầng BareMetal, kết hợp với các node Master và Worker.</p>
                                <p class='typo-14'>Hệ thống Object Storage (chuẩn S3) được cấu hình linh hoạt thông qua các VM trên Proxmox VE. Giải pháp bắt đầu với tối thiểu 3 máy chủ vật lý cho cluster và chỉ cần 1 máy Proxmox VE cho lưu trữ đối tượng.</p>
                                
                                <p class='typo-14'>&nbsp;</p>
                                <ul>
                                    <li><p class='typo-14'>Triển khai trên BareMetal & Proxmox VE: Kết hợp hiệu quả giữa hiệu năng vật lý và ảo hóa linh hoạt.</p></li>
                                    <li><p class='typo-14'>Hiệu năng cao và khả năng mở rộng: Phù hợp với các hệ thống yêu cầu xử lý dữ liệu lớn và tải công việc cao.</p></li>
                                    <li><p class='typo-14'>Hỗ trợ ứng dụng quy mô lớn: Tối ưu cho môi trường production và các nền tảng microservice.</p></li>
                                    <li><p class='typo-14'>Lưu trữ linh hoạt: Cấu hình Object Storage (S3) dễ dàng trên VM Proxmox VE.</p></li>
                                    <li><p class='typo-14'>Quản lý dữ liệu mạnh mẽ: Phục vụ tốt cho các nhu cầu phân tích và xử lý dữ liệu phân tán.</p></li>
                                </ul>
                                `)}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} className='MuiGrid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/en/scalable-cluster.png")}</MuiGrid>
                            <DividerComponent />
                        </MuiGrid>
                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>


            <FooterVn />
        </Sysfont>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default ScalableVN;